module.exports = __webpack_public_path__ + "media/images/common/right_product_box_head_bg-90ff63f998fbe3d4a10204f314ebf726.png";